import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.scss";
import Question from "../../containers/question/";
class PrintStudentLog extends Component {
  constructor(props) {
    super(props);
    console.log("print", props);
  }

  componentWillMount() {}

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    this.state = {
      challenge: props.challenge
    };
  }

  render() {
    return (
      <div className="print-student-log">
        <h1>{this.props.log.title}</h1>
        <h2>
          {this.props.student.role == "highschool"
            ? "High School Student: "
            : this.props.student.role == "undergrad"
                ? "Undergraduate: "
                : "Medical Student: "}
          {this.props.student.firstName} {this.props.student.lastName}
        </h2>
        <br />
        {this.props.log.directions &&
          <div
            className=""
            dangerouslySetInnerHTML={{
              __html: this.props.log.directions
            }}
          />}
        {this.props.log.groups.map(
          (group, groupId) =>
            group &&
            <div key={`${this.props.student.uid}${groupId}`}>
              <h3>{group.title}</h3>
              <div>
                {(group.questions || [])
                  .map((question, questionId) => (
                    <Question
                      key={`${this.props.student.uid}${groupId}${questionId}`}
                      question={question}
                      value={
                        this.props.responses &&
                          this.props.responses.group &&
                          this.props.responses.group[groupId]
                          ? this.props.responses.group[groupId].question[
                              questionId
                            ]
                          : null
                      }
                      responses={this.props.responses}
                      log={this.props.log}
                      print={true}
                    />
                  ))}
              </div>
            </div>
        )}

      </div>
    );
  }
}

export default PrintStudentLog;



// WEBPACK FOOTER //
// ./src/containers/print-student-log/index.js